import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  units: [],
};

const getters = {
  allUnits: (state) => state.units,
};

const actions = {
  async fetchUnits({ commit }, params = {}) {
    try {
      const response = await axios.get("/unit", { params: prm(params) });
      commit("setUnits", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch units:", error);
    }
  },
  async createUnit({ commit }, unit) {
    try {
      const response = await axios.post("/unit", unit);
      commit("addUnit", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create unit:", error);
      throw error;
    }
  },
  async fetchUnitById(_, id) {
    try {
      const response = await axios.get(`/unit/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch unit:", error);
      throw error;
    }
  },
  async updateUnit({ commit }, unit) {
    try {
      const response = await axios.put(`/unit/${unit.id}`, unit);
      commit("updateUnit", response.data);
    } catch (error) {
      console.error("Failed to update unit:", error);
      throw error;
    }
  },
  async deleteUnitById({ commit }, id) {
    try {
      const response = await axios.delete(`/unit/${id}`);
      commit("removeUnit", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete unit:", error);
      throw error;
    }
  },
};

const mutations = {
  setUnits(state, units) {
    state.units = units.data; // Ensure this matches your API's response structure
  },
  addUnit(state, unit) {
    state.units.push(unit);
  },
  updateUnit(state, updatedUnit) {
    const index = state.units.findIndex(
      (unit) => unit.id === updatedUnit.id
    );
    if (index !== -1) {
      state.units.splice(index, 1, updatedUnit);
    }
  },
  removeUnit(state, id) {
    state.units = state.units.filter(
      (unit) => unit.id !== id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
